import { computed } from 'vue'
import { form, errors, isSubmitting } from './state'
import { validateForm } from './methods/validate-form'
import { prepareData } from './methods/prepare-data'
import { submitForm } from './methods/submit-form'
import { resetForm } from './methods/reset-form'
import { initForm } from './methods/init-form'

/**
 * Öneri oluşturma formu için composable
 * @returns {Object} Form state ve metodları
 */
export const useSuggestionCreate = () => {
  /**
   * Formun geçerli olup olmadığını kontrol eder
   */
  const isFormValid = computed(() => {
    return form.suggestion.trim().length > 0
  })

  return {
    // State
    form,
    errors,
    isSubmitting,
    isFormValid,
    
    // Methods
    validateForm,
    prepareData,
    submitForm,
    resetForm,
    initForm
  }
}
